export const STATSIG_API_KEYS = {
  rxn_production: 'client-QaNCY4HS1v9OfZTsLHclrCOG5CPncfrsffjL7eLPglP',
  rxn_dev: 'client-X9pOM9l97rKJKdymt3b9BV7hS7DvbdyqOPWZARhMwT7',
  react_production: 'client-fJ4xOQB9yzcuBdr4C9Lz4u69DEoWbsHuw8QEKo5NVX8',
  react_dev: 'client-Cc1wjcgpZaTJEtboMT9BaBxSwBxmlVt1JUExYznKBsW',
};
